import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContainer: {
    width: 90,
    height: 90,
    borderRadius: theme.borderRadius.full,
    borderWidth: 2.5,
    borderColor: colors.borderBrand,
  },
  text: {
    color: colors.textPrimary,
  },
  descriptionContainer: {
    width: '80%',
  },
}));
